<app-home-jumbotron></app-home-jumbotron>

<!-- <div class="container my-5">
  <app-home-buy-now></app-home-buy-now>
</div> -->
<!-- <div class="container-fluid">
  <div class="bb-light mb-4"></div>
</div> -->
<div class="container mb-5">
  <app-home-popular-categories></app-home-popular-categories>
</div>
<!-- <app-home-explore></app-home-explore> -->

<div class="container">
  <div class="bb-light mb-5"></div>
  <h2 class="text-center">Testimonials & Reviews</h2>
  <iframe
    id="testimonialto-rubbl-homepage-tag-all-light"
    src="https://embed-v2.testimonial.to/w/rubbl-homepage?theme=light&card=base&loadMore=on&initialCount=20&tag=all&hideDate=on"
    frameborder="0"
    scrolling="no"
    width="100%"
  ></iframe>
</div>

<div class="mb-6 8919283198239812389123981238912">
  <app-home-renting-info></app-home-renting-info>
</div>
<common-marketing-hero></common-marketing-hero>

<div (appear)="showLast = true">
  <div *ngIf="showLast">
    <div class="tire-background">
      <div class="container">
        <common-services-section-lp></common-services-section-lp>
      </div>

      <!-- <div class="container mt-5 pt-5">
        <app-home-we-know></app-home-we-know>
      </div> -->
      <!-- <div class="container-fluid user-testimonial-container">
        <common-user-testimonial-carousel></common-user-testimonial-carousel>
      </div> -->
    </div>
    <div class="container-fluid pb-5">
      <common-jumbotron
        header="Increase your utilization"
        subHeader="Put your idle machines to work, and earn new rental revenue doing it.​"
        imagePath="/pubweb/marketplace/images/backgrounds/excavator-and-dump-trucks.jpg"
        buttonText="List your machines"
        (buttonClick)="goToListYourMachines()"
      ></common-jumbotron>
    </div>

    <div class="bg-grey mt-4">
      <div class="container py-5">
        <div class="row">
          <div class="col-md-6">
            <common-faq-dropdown-list></common-faq-dropdown-list>
          </div>
          <div class="col-md-5 offset-md-1 mt-4 mt-md-0">
            <div class="text-center subhead">Get in touch</div>
            <iframe
              style="width: 100%; position: static; border: none; display: block; overflow: hidden; height: 633px"
              src="https://share.hsforms.com/1KxX-0RBiS1SIlReJw9awDQc9pim"
            >
            </iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<common-footer></common-footer>
